import { twMerge } from 'tailwind-merge';

interface SeparatorProps {
  className?: string;
  vertical?: boolean;
}

export const Separator = ({ className, vertical }: SeparatorProps) => {
  return (
    <div
      className={twMerge(
        `border-border-border border-t border-solid`,
        vertical && 'border-t-none border-l',
        className
      )}
    />
  );
};
